import axios from 'axios'
import { Message } from 'view-design'
import Vue from 'vue'
import Cookies from 'js-cookie'
// import { router } from '@/router'
import {sm2} from 'sm-crypto'

class HttpRequest {
  constructor (baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig (sign) {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        // 添加xsrf验证
        "X-Xsrftoken": Cookies.get('_xsrf'),
        "sign": sign
      }
    }
    return config
  }
  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors (instance, url) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      // 添加全局的loading...
      if (!Object.keys(this.queue).length) {
        // Spin.show() // 不建议开启，因为界面不友好
      }
      this.queue[url] = true
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      this.destroy(url)

      let datares = res.data
      // console.log(datares)
      if (typeof datares === "string") {
        let decryptData = sm2.doDecrypt(datares, '9ffd2fd68efe551441a93eacfb3f48109eed1710f014519e5c1d67dfbaade5ed', 1) // 解密结果
        datares = JSON.parse(decryptData)
      }
      // console.log(datares)
      res.data = datares
      const { data, status, request } = res
      // console.log(data)
      return { data, status, request }
    }, error => {
      this.destroy(url)
      if (error.response.status === '401' || error.response.status === 401) {
        location.reload()
      } else if (error.response.status === 403) {
        Message.error({
          content: `你没有权限, 请联系管理员`,
          duration: 8,
          closable: true
        })
      } else {
        Message.error({
          content: `${error.response.status}-错误`,
          duration: 8,
          closable: true
        })
      }
      return Promise.reject(error)
    })
  }

  stringifyObjectValues(obj) {
  // 创建一个空对象来存放转换后的值
  const newObj = {};
  // 遍历原始对象的所有可枚举属性
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      // 将值转换为字符串，并存储在新对象中
        obj[key] = obj[key] || "";
        newObj[key] = obj[key].toString();
        if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
          // 是对象，则转换为JSON字符串
          newObj[key] = JSON.stringify(obj[key]);
        }
    }
  }
  // 返回新对象
  return newObj;
  }
  request (options) {
    const instance = axios.create()
    // 添加安全签名
    const privateKey = '19809439c9053a9dbffe4f81780b224ae7aa5ca28dbdd9c26757e12e06121e8c'
    let urldata = options.data
    if (options.method == 'get'){
      urldata = options.params
    }
    const jdata = this.stringifyObjectValues(urldata)
    // console.log(JSON.stringify(jdata))
    const sigValueHex = sm2.doSignature(JSON.stringify(jdata), privateKey)
    options = Object.assign(this.getInsideConfig(sigValueHex), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
